import { z } from 'zod';

const BsBonusFieldsSchema = z.object({
  id: z.number(),
  status: z.string(),
  proposedAt: z.nullable(z.string()),
  activatedAt: z.nullable(z.string()),
  deactivatedAt: z.nullable(z.string()),
  completedAt: z.nullable(z.string())
});

const BsBonusSchema = z.object({
  allowPlayerToParticipate: z.boolean(),
  bonuses: z.array(BsBonusFieldsSchema),
  bonusTemplateId: z.number(),
  templateName: z.string(),
  betType: z.array(z.string()).optional(),
  isBonusRepeatable: z.boolean(),
  cantWagerAfterBonusTemplateEnds: z.boolean(),
  timeToActivate: z.number(),
  wagerMultiplier: z.number(),
  bonusType: z.string(),
  contentTemplate: z.string(),
  startedAt: z.string(),
  endedAt: z.string(),
  startedAtTimestamp: z.number(),
  endedAtTimestamp: z.number()
});

const CrmRmBonusSchema = z.object({
  bonusId: z.number(),
  bonusModelId: z.number(),
  bonusName: z.string(),
  bonusTitle: z.string(),
  bonusDescr: z.string(),
  isCashback: z.boolean(),
  bonusEndTime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  imageUrl: z.string(),
  promoPage: z.string(),
  state: z.number(),
  stateDesc: z.string(),
  leadId: z.number(),
  userId: z.number(),
  fullName: z.string(),
  currency: z.string(),
  bonusSum: z.string().nullable(),
  inputBetCount: z.number(),
  inputBetTotal: z.string(),
  inputMaxCount: z.number(),
  inputMaxTotal: z.string(),
  incomeSum: z.string(),
  outputBetCount: z.number(),
  outputBetTotal: z.number(),
  outputMaxCount: z.number(),
  outputMaxTotal: z.nullable(z.number()),
  bonusTime: z.object({
    sec: z.number(),
    usec: z.number()
  }),
  incomeTime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  outputTime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  maxActivationTime: z.object({
    sec: z.number(),
    usec: z.number()
  }),
  acceptMode: z.number(),
  acceptModeDesc: z.string(),
  rejectMode: z.number(),
  rejectModeDesc: z.string(),
  isWager: z.boolean(),
  bonusMinSum: z.string(),
  bonusMaxSum: z.string(),
  incomeDepositMin: z.string(),
  incomeDepositMax: z.string(),
  outputBetType: z.number(),
  limitCalcPercent: z.nullable(z.number()),
  instrumentList: z.array(z.number())
});

const CrmFsBonusSchema = z.object({
  freespinId: z.number(),
  bonusModelId: z.number(),
  remainCount: z.number(),
  freespinName: z.string(),
  freespinNote: z.string(),
  state: z.number(),
  stateDesc: z.string(),
  serviceId: z.nullable(z.string()),
  categoryId: z.nullable(z.string()),
  gameCode: z.nullable(z.number()),
  gameId: z.string(),
  partnerGameId: z.string(),
  leadId: z.number(),
  userId: z.number(),
  gameName: z.string(),
  provider: z.nullable(z.string()),
  currency: z.nullable(z.string()),
  freespinCount: z.number(),
  betLevel: z.number(),
  bet: z.number(),
  lineNumber: z.number(),
  incomeDepositMin: z.string(),
  incomeDepositMax: z.string(),
  freespinTime: z.object({
    sec: z.number(),
    usec: z.number()
  }),
  activationTime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  startwagertime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  expireTime: z.object({
    sec: z.number(),
    usec: z.number()
  }),
  freespinEndTime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  acceptMode: z.number(),
  outputBetCount: z.number(),
  outputBetTotal: z.number(),
  outputMaxCount: z.number(),
  outputMaxTotal: z.nullable(z.string()),
  incomeTime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  outputTime: z.nullable(
    z.object({
      sec: z.number(),
      usec: z.number()
    })
  ),
  maxActivationTime: z.object({
    sec: z.number(),
    usec: z.number()
  }),
  isWager: z.boolean(),
  isGameManagement: z.boolean(),
  acceptModeDesc: z.string()
});

const CrmBonusResponseSchema = z.object({
  type: z.union([
    z.literal('crm_funds'),
    z.literal('crm_risk_free'),
    z.literal('crm_free_spins')
  ]),
  data: z.union([CrmFsBonusSchema, CrmRmBonusSchema]),
  currency: z.string().optional()
});

const BsBonusResponseSchema = z.object({
  type: z.union([z.literal('bs_pwb'), z.literal('bs_pws'), z.literal('bs_fs')]),
  data: BsBonusSchema,
  currency: z.string().optional()
});

export const GetBonusesResponseSchema = z.object({
  bonuses: z
    .array(z.union([BsBonusResponseSchema, CrmBonusResponseSchema]))
    .optional()
});

export const GetParsedBonusesSchema = z
  .array(z.union([BsBonusResponseSchema, CrmBonusResponseSchema]))
  .optional();
